// StatsSection.jsx
import React, { useState, useEffect } from 'react';
import './StatsSection.css';

const StatsSection = () => {
  const [emissionsBalance, setEmissionsBalance] = useState("Loading...");
  const [lastUpdatedBlock, setLastUpdatedBlock] = useState(null);
  const [holdersCount, setHoldersCount] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch emissions data
        const emissionsResponse = await fetch('https://explorer.bf1337.org/api/v2/addresses/0xcAe6f602c9b135e4D0F3A99375d7c350124e59c5');
        const emissionsData = await emissionsResponse.json();
        
        // Fetch holders data
        const holdersResponse = await fetch('https://explorer.bf1337.org/api/v2/tokens/0x42621ffA9256e0F935F2C84ea40CeE970F46C566/holders');
        const holdersData = await holdersResponse.json();
        
        // Update states
        const num = parseFloat(emissionsData.coin_balance) / 1e18;
        const formattedBalance = num.toLocaleString(undefined, { 
          maximumFractionDigits: 3 
        });
        
        setEmissionsBalance(formattedBalance);
        setLastUpdatedBlock(emissionsData.block_number_balance_updated_at);
        setHoldersCount(holdersData.items[0].token.holders);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

const statsData = [
  {
    title: "Based Emissions",
    value: emissionsBalance,
    subtitle: "60k BASED Day",
    lastUpdated: lastUpdatedBlock ? `Updated #${lastUpdatedBlock}` : null
  },
  {
    title: "Total Staked",
    value: "Coming Soon",
    subtitle: "$bSIM",
    lastUpdated: holdersCount ? `${holdersCount} Holders` : null
  },
  {
    title: "BASED Staked",
    value: "N/A",
    subtitle: "BASED"
  },
  {
    title: "Creatures",
    value: "N/A",
    subtitle: "Mining"
  },
  {
    title: "Miners Earnings",
    value: "N/A",
    subtitle: "BASED To Date"
  },
  {
    title: "Miners",
    value: "N/A",
    subtitle: "Acc Rate"
  },
  {
    title: "Nodes",
    value: "N/A",
    subtitle: "Validating"
  },
  {
    title: "Validator Earnings",
    value: "N/A",
    subtitle: "BASED To Date"
  },
  {
    title: "Validators",
    value: "N/A",
    subtitle: "Acc Rate"
  }
];

return (
  <section className="stats-section">
    <div className="stats-grid">
      {statsData.map((stat, index) => (
        <div key={index} className="stat-card">
          {stat.lastUpdated && (
            <div className="last-updated">
              {stat.lastUpdated}
            </div>
          )}
          <div className="stat-header">
            <h3 className="stat-title">{stat.title}</h3>
          </div>
          <div className="stat-content">
            <span className="stat-value">{stat.value}</span>
            <p className="stat-subtitle">{stat.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);
};

export default StatsSection;